import React from 'react';

const Loader = ({size, className}) => {
    return (
      <span className={`loader loader--${size} ${className}`} />
    );
};

export default Loader;
